<template>
  <el-dialog
    :visible.sync="dialogAddVisible"
    width="30%"
    :title="(editData ? '编辑' : '新建') + '角色'"
    center
    @close="resetForm"
  >
    <el-form
      :model="form"
      label-width="100px"
      ref="addFormRef"
      :rules="addRules"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogAddVisible = false;
          resetForm();
        "
        >取消</el-button
      >
      <el-button type="primary" @click="submitEdit">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { editRoleApi } from '@/api/user.js';
export default {
  props: ['editData'],
  data() {
    return {
      dialogAddVisible: false,
      form: {
        name: '',
        remark: '',
        roleId: '',
      },
      addRules: {
        name: [{ required: true, message: '名称是必填的', trigger: 'blur' }],
      },
    };
  },
  inject: ['reload'],
  methods: {
    resetForm() {
      this.form = {};
      this.$refs.addFormRef.resetFields();
    },
    submitEdit() {
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          if (this.editData) {
            this.handleEdit();
          } else {
            this.handleAdd();
          }
        } else {
          this.$message.error('请仔细检查格式！');
        }
      });
    },
    // 添加角色
    async handleAdd() {},
    // 编辑角色
    async handleEdit() {
      const data = `roleId=${this.form.roleId}&name=${this.form.name}&remark=${this.form.remark}`;
      const res = await editRoleApi(data);
      if (res.code == 200) {
        this.$message.success('编辑成功');
        this.reload();
      }
    },
  },
};
</script>